<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="名称" prop="productName">
        <el-input v-model="form.productName" placeholder="输入名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="行业" prop="industryId">
        <!-- 单选按钮 -->
        <el-radio-group v-model="form.industryId">
          <el-radio v-for="item in industryOptions" :key="item.key" :label="item.key">{{item.value}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="需求描述" prop="notes">
          <el-input type="textarea" show-word-limit maxlength="2000"
           :rows="3" v-model="form.notes" placeholder="描述需求" :clearable="true"></el-input>
          <el-button
            @click="createPosition"
            class="filter-item"
            type="primary"
            icon="el-icon-magic-stick"
            size="small"
            style="margin-top:5px;"
         >生成岗位</el-button>
      </el-form-item>
      <el-form-item label="封面" prop="productCover">
        <uploadImg
            v-model="form.productCover"
            :imgSize="1"
            :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="群二维码" prop="groupCode">
        <uploadImg
            v-model="form.groupCode"
            :imgSize="1"
            :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="任务">
        <div style="margin-bottom: 20px;">
          <el-button
              size="small"
              @click="addTab()"
              type="primary"
          >
            添加任务
          </el-button>
        </div>
        <el-tabs v-model="editableTabsValue"  type="border-card"  closable @tab-remove="removeTab"  style="min-height: 400px;">
          <el-tab-pane
              v-for="(item, index) in form.clockInThemeList"
              :key="item.id + ''"
              :label="item.title"
              :name="item.id + ''"
          >
             <span slot="label">
                <PositionShow v-model="item.certId"></PositionShow><span>{{item.title}}</span>
            </span>
            <AddTaskItem :value="item"
                         @input="value => updateItemValue(index, value)" :default-dir-id="form.sourceDir"></AddTaskItem>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="success" @click="confirm('form')">确定</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  addProduct,
  updateProduct,
  getProductInfo,
  getProductCateOption
} from '@/api/merchant/service/product'
import {
  getIndustryOptions
} from '@/api/merchant/agent'
import uploadImg from '@/components/uploadImage/index.vue'
import uploadVideo from '@/components/uploadVideo'

/**
 * 富文本工具
 */
import { quillEditor, Quill } from 'vue-quill-editor'
import { replayContent, initEditor, option, initTitle } from '@/utils/editor'
import {
  addProject,
  autoCreatePosition,
  updateProject,
  updateProjectInfo
} from '@/api/merchant/service/project'
import AddTaskItem from '@/components/project/AddTaskItem.vue'
import PositionSelection from '@/components/project/PositionSelection.vue'
import PositionShow from '@/components/project/PositionShow.vue'
import loading from '@/libs/loading'
initEditor(Quill)

export default {
  name: 'addProject',
  components: {
    PositionShow,
    PositionSelection,
    AddTaskItem,
    uploadImg,
    quillEditor,
    uploadVideo
  },
  data () {
    return {
      industryOptions: [],
      newTabInx: 0,
      editableTabsValue: '2',
      productCateOption: [],
      id: '', // id
      form: {
        groupCode: '', // 群二维码
        productCover: '', // 图标
        productName: '', // 活动名称
        endTime: '', // 结束时间
        notes: '',
        industryId: '',
        clockInThemeList: [],
        sourceDir: '0'
      },
      replyOptionLoading: false,
      editorOption: option,
      rules: {
        categoryId: [
          {
            required: true,
            message: '请选择分类',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        icon: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'blur'
          }
        ],
        completionDays: [
          {
            required: true,
            message: '请填写周期',
            trigger: 'blur'
          }
        ]
      },
      itemRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        icon: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'blur'
          }
        ],
        completionDays: [
          {
            required: true,
            message: '请填写周期',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getIndustryOptions()
  },
  methods: {
    addTab (targetName) {
      this.newTabInx++
      let tabs = this.form.clockInThemeList
      let newTabName = '新建内容' + this.newTabInx + '[请修改]'
      tabs.push({
        id: this.newTabInx,
        title: newTabName
      })
      this.editableTabsValue = this.newTabInx + ''
    },
    removeTab (targetName) {
      console.log('removeTab', targetName)
      this.$confirm('确认删除任务吗', '确认操作', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.confirmRemoveTab(targetName)
        })
        .catch(() => {
        })
    },
    confirmRemoveTab (targetName) {
      let tabs = this.form.clockInThemeList
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.id + '' === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.id + ''
            }
          }
        })
      }

      this.editableTabsValue = activeName
      this.form.clockInThemeList = tabs.filter(tab => tab.id + '' !== targetName)
    },
    getIndustryOptions () {
      getIndustryOptions().then(res => {
        this.industryOptions = res
        this.form.industryId = res[0].key
      })
    },
    getInfo (id) {
      let that = this
      updateProjectInfo(id)
        .then(res => {
          that.form = res
          that.editableTabsValue = that.form.clockInThemeList[0].title
        })
    },
    confirm () {
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    getProductCateOption () {
      let that = this
      getProductCateOption().then(res => {
        that.productCateOption = res
      })
    },
    onEditorBlur (quill) {
      console.log('editor blur!', this.form.content, quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', this.form.content, quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    },
    // 自动创建岗位
    createPosition () {
      let error = false
      let loading = this.$loading({
        lock: true,
        text: '正在分析需求...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      autoCreatePosition(this.form.industryId, this.form.notes).then(res => {
        this.form.clockInThemeList = res
        this.form.clockInThemeList.forEach((item, index) => {
          item.id = index + 1
        })
        this.editableTabsValue = '1'
        loading.close()
      }).catch(err => {
        loading.close()
        error = true
      })
      setTimeout(() => {
        loading.close()
        if (error) {
          return
        }
        loading = this.$loading({
          lock: true,
          text: '正在匹配案例...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }, 2000)
      setTimeout(() => {
        loading.close()
        if (error) {
          return
        }
        loading = this.$loading({
          lock: true,
          text: '正在生成岗位...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }, 5000)
    },
    updateItemValue (index, value) {
      console.log(index, value)
      this.$set(this.form.clockInThemeList, index, value)
    },
    // 新增
    getCreate (forms) {
      let that = this
      that.form.clockInThemeList.forEach(item => {
        item.id = null
      })
      that.$refs[forms].validate(valid => {
        if (valid) {
          addProject(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.back()
            // that.$router.push("/demo/helper/keyword");
          })
        }
      })
    },

    // 编辑
    getModify (forms) {
      let that = this
      that.form.clockInThemeList.forEach(item => {
        if (item.id < 9999999) {
          item.id = null
        }
      })
      that.$refs[forms].validate(valid => {
        if (valid) {
          updateProject(that.id, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.back()
          })
        }
      })
    }

  },
  mounted () {
    let that = this
    that.id = that.$route.query.id
    if (that.id != null) {
      that.getInfo(that.id)
    }
  }
}

</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
